define(function(require) {
	const IpsModel = require('civicsBase/ipsModel');
  return IpsModel.extend({
    urlRoot: '/delegate/civics-api/api/core/detailpage/generate/all?overwrite={0}',
    url: function() {
	    return this.urlRoot.format(this.overwrite);
		},
  });
});
